import { Component, OnInit, Inject, AfterViewInit, ViewChild, ViewContainerRef, ComponentRef, OnDestroy, ElementRef, ChangeDetectorRef, Injector, isDevMode } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { UntypedFormGroup } from '@angular/forms';
import { GlobalApiService } from '@app/system/services/global-api.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { BuilderService } from '@app/components/controls/utilities/services/builder.service';
import { DropDownModel } from '../controls/utilities/models/drop-down-model';

@Component({
	selector: 'app-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('content', { read: ViewContainerRef })
	vcRef: ViewContainerRef;
	@ViewChild('buttonContainer') set focus(buttonContainer: ElementRef) {
		if (buttonContainer && this.data.action === 'alert') {
			setTimeout(() => {
				if (Array.isArray(this.data.buttons)) {
					const childButtons = buttonContainer.nativeElement.children;
					for (let i = 0; i < childButtons.length; i++) {
						if (childButtons[i].autofocus) {
							childButtons[i].focus();
							break;
						}
					}
				}
			}, 100);
		}
	};
	@ViewChild('sample') sample: ElementRef;

	componentRef: ComponentRef<any>;
	dialogCloseData;
	loader = true;
	formObject;
	form: UntypedFormGroup;
	submitDisable = false;
	clearTimeout;
	popupLoader = false;
	componentReference;
	formFields: any = [];
	config = { fxFlex: 100 };
	baseService: any;
	isDev = isDevMode();
	addScrollClass = false;

	constructor(
		public dialogRef: MatDialogRef<PopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any = {},
		public gfService: GlobalFunctionService,
		public locale: LocaleService,
		private cdref: ChangeDetectorRef,
		private controlService: BuilderService,
		private globalApiService: GlobalApiService,
		private appInit: AppInitializerService,
		private injector: Injector
	) {
		if (!navigator.onLine) {
			this.dialogRef.close();
		}
		this.injectService();
	}

	async injectService() {
		const service = await import('@app/system/services/base.service');
		this.baseService = this.injector.get(service.BaseService);
	}

	async ngOnInit() {
	}

	async ngAfterViewInit() {
		if (navigator.onLine) {
			if (this.data.action === 'dynamic') {
				setTimeout(async () => {
					let data = [];
					if (this.data.componentData) {
						data = this.data.componentData;
						if (typeof this.data.componentData === 'object' && !Array.isArray(this.data.componentData)) {
							data = [this.data.componentData];
						}
					}
					data = data.concat([{ variableName: 'popupRef', value: this.dialogRef }]);
					this.componentReference = await this.gfService.loadComponent(this.data.component, this.vcRef, data);
					if (this.componentReference && this.componentReference.addScrollClassToPopup) {
						this.addScrollClass = true;
					}
					this.loader = false;
				});
			} else if (this.data.action === 'filter') {
				this.form = this.controlService.formGroupBuilder(this.data.fieldList);
				this.formObject = { form: this.form, fields: this.data.fieldList };
				let subscribe;
				const authorsField = this.data.fieldList.find((items) => items.fieldColumn === 'authors');
				if (authorsField && navigator.onLine) {
					this.form.controls.authors.valueChanges.subscribe((controlResp) => {
						if (subscribe && !subscribe['closed']) {
							subscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp
								};
								const header: any = {};
								let selectedValue = [];
								if (authorsField.selectedValue.length) {
									authorsField.selectedValue.map(items => {
										if (items.isAdd && !items.isDelete) {
											selectedValue.push(items.key);
										}
									});
								}
								subscribe = this.globalApiService.getUsers(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.userID)) {
														return items;
													}
												});
											}
											authorsField.options = response.records.map((data) => {
												return {
													key: data.userID,
													value: `${data.firstName}${data.lastName
														? ' ' + data.lastName
														: ''}`,
													prefix: {
														type: 'image',
														value: data.profilePicURL
													},
													shortInfo: this.baseService.getUserShortInfo(data)
												};
											});
										} else {
											authorsField.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										authorsField.options = [];
									}
								);
							} else {
								authorsField.options = [];
							}
						}, this.appInit.configuration.searchDelay);
					});
				}
				let skillSubscribe;
				const skillsField = this.data.fieldList.find((items) => items.fieldColumn === 'skills');
				if (skillsField && navigator.onLine) {
					this.form.controls.skills.valueChanges.subscribe((controlResp) => {
						if (skillSubscribe && !skillSubscribe['closed']) {
							skillSubscribe.unsubscribe();
						}
						if (this.clearTimeout) {
							clearTimeout(this.clearTimeout);
						}
						this.clearTimeout = setTimeout(() => {
							if (controlResp && typeof controlResp === 'string') {
								const apiData = {
									searchString: controlResp,
									termsetid: 1
								};
								const header: any = {};
								let selectedValue = [];
								if (skillsField.selectedValue.length) {
									skillsField.selectedValue.map(items => {
										if (items.isAdd && !items.isDelete) {
											selectedValue.push(items.key);
										}
									});
								}
								skillSubscribe = this.globalApiService.getTerm(apiData, header).subscribe(
									(response) => {
										if (response && response.records.length) {
											if (selectedValue.length) {
												response.records = response.records.filter(items => {
													if (!selectedValue.includes(items.termID)) {
														return items;
													}
												});
											}
											skillsField.options = response.records.map((data) => {
												return {
													key: data.termID,
													value: data.term
												};
											});
										} else {
											skillsField.options = [];
										}
									},
									(error) => {
										this.gfService.errorHandler(error, {
											snackBar: {
												position: 'before'
											}
										});
										skillsField.options = [];
									}
								);
							} else {
								skillsField.options = [];
							}
						}, this.appInit.configuration.searchDelay);
					});
				}
				this.loader = false;
			} else if (this.data.action === 'alert') {
				this.loader = false;
				this.cdref.detectChanges();
				// setTimeout(() => {
				// 	if (Array.isArray(this.data.buttons)) {
				// 		const childButtons = this.buttonContainer.nativeElement.children;
				// 		for (let i = 0; i < childButtons.length; i++) {
				// 			if (childButtons[i].autofocus) {
				// 				childButtons[i].focus();
				// 				break;
				// 			}
				// 		}
				// 	}
				// }, 100);
			} else if (this.data.action === 'users') {
				this.loader = false;
				if (Array.isArray(this.data.usersList)) {
					for (const data of this.data.usersList) {
						const shortInfo = [];
						data.name = `${data.firstName}${data.lastName
							? ' ' + data.lastName
							: ''}`;
						if (data.designation && data.designation.name) {
							data.name += ` (${data.designation.name})`
						}
						if (data.company && data.company.name) {
							shortInfo.push(
								{
									value: data.company.name
								}
							);
						}
						if (data.department && data.department.name) {
							shortInfo.push(
								{
									value: data.department.name
								}
							);
						}
						if (data.city && data.city.name) {
							shortInfo.push(
								{
									value: data.city.name
								}
							);
						}
						if (data.location && data.location.name) {
							shortInfo.push(
								{
									value: data.location.name
								}
							);
						}
						data.shortInfo = shortInfo;
					}
				}
			} else if (this.data.action === 'updatePreference') {
				this.baseService.formView = true;
				this.loader = true;
				this.submitDisable = true;
				const language: DropDownModel = {
					fieldColumn: 'language',
					fieldType: 'dropDown',
					isHidden: false,
					isMultiple: false,
					isReadonly: false,
					isRequired: true,
					options: [],
					additionalMetaData: {},
					fieldCaption: this.locale.translate('language'),
					fieldHelpText: null,
					fieldHelpTextLong: null,
					fieldOrder: 1,
					value: null
				};
				language.options = [
					{
						key: 'en',
						value: 'English-US'
					},
					{
						key: 'ta',
						value: 'Tamil'
					}
				];
				if (sessionStorage.getItem('locale')) {
					language.value = sessionStorage.getItem('locale');
				} else {
					language.value = language.options[0].key;
				}
				this.formFields = [language];
				this.loader = false;
				this.submitDisable = false;
			}
		}
	}

	submit() {
		if (navigator.onLine) {
			if (this.data.action === 'updatePreference') {
				this.updatePreference();
			}
		}
	}

	updatePreference() {
		if (this.formObject && this.formObject.form) {
			this.submitDisable = true;
			if (this.formObject.form.valid) {
				this.loader = true;
				const formValue = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				sessionStorage.setItem('locale', formValue.language);
				this.locale.switchLanguage(formValue.language);
				this.loader = false;
				this.submitDisable = false;
				if(this.gfService.sessionUser.resourceTypes){
					delete this.gfService.sessionUser.resourceTypes;
				}
				this.dialogRef.close();
			}
		}
	}

	formObjectReader(record) {
		this.formObject = record;
	}

	routeWorkgroup() {
		if (navigator.onLine) {
			this.dialogRef.close();
			const queryParams = {
				tab: 'joined_workgroups',
				send_request: 'active'
			};
			this.gfService.routeNavigation('/workgroup', queryParams);
		}
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}

	close(popupClose: boolean = false) {
		if (navigator.onLine) {
			// if (!popupClose && this.baseService.formView && !this.isDev && this.data.action !== 'alert') {
			// 	this.alertPopup();
			// 	return;
			// }

			if (this.componentReference && this.componentReference.dialogClose) {
				this.componentReference.dialogClose();
			} else {
				this.dialogRef.close(this.dialogCloseData || 'close');
			}
			this.baseService.resourcePopupTriggered = false;
		}
	}

	// alertPopup() {
	// 	const dialogRef = this.popup.open(PopupComponent, {
	// 		panelClass: ['custom-panel'],
	// 		autoFocus: false,
	// 		data: {
	// 			action: 'alert',
	// 			classes: 'warning',
	// 			popup: true,
	// 			icon: 'warning',
	// 			title: this.locale.translate('close_form'),
	// 			content: this.locale.translate('close_form_text'),
	// 			buttons: [
	// 				{
	// 					type: 'main-action',
	// 					caption: this.locale.translate('yes'),
	// 					key: 'yes'
	// 				},
	// 				{
	// 					type: 'main-action',
	// 					caption: this.locale.translate('no'),
	// 					key: 'no',
	// 					autoFocus: true
	// 				}
	// 			]
	// 		},
	// 		disableClose: true,
	// 		maxWidth: '560px'
	// 	});
	// 	dialogRef.afterClosed().subscribe((resp) => {
	// 		if (resp) {
	// 			if (resp.key === 'yes') {
	// 				this.close(true);
	// 			}
	// 		}
	// 	});
	// }


	buttonTrigger(data) {
		this.dialogRef.close(data);
	}

	getFlexOptions() {
		return '1 1 200px';
	}

	search() {
		if (navigator.onLine) {
			if (this.formObject && this.formObject.form) {
				this.submitDisable = true;
				if (this.formObject.form.valid) {
					this.loader = true;
					const formValue = this.gfService.fieldSubmitApiValueConstruct(
						this.formObject.form.getRawValue(),
						this.formObject.fields
					);
					this.dialogRef.close(this.gfService.JSONMerge({
						formValue
					}, this.formObject));
				} else {
					this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
					this.submitDisable = false;
				}
			}
		}
	}

	ngOnDestroy() {
		if (this.data.triggerEl) {
			const el: HTMLElement = this.data.triggerEl['_elementRef'].nativeElement;
			setTimeout(() => {
				el.blur();
			});
		}
		if (this.baseService.formView && this.data.action !== 'alert') {
			this.baseService.formView = false;
		}

	}
}
